import "./BacktestResults.module.css";
import Header from "@/reusable_sections/Header";
import EquityCurveVisualizer from "./sections/EquityCurveVisualizer";
import PerformanceAnalyticsGrid from "./sections/PerformanceAnalyticsGrid";
import HistoricalLedger from "./sections/HistoricalLedger";
import Footer from "@/reusable_sections/Footer";
export default function BacktestResultsPage() {
  return <div>
      <Header />
      <EquityCurveVisualizer />
      <PerformanceAnalyticsGrid />
      <HistoricalLedger />
      <Footer />
    </div>;
}